import { updateUserProperties } from "analytics";
import { getEntitlements } from "helpers/entitlements";
import { groupExamsByCategory } from "helpers/exams";
import { useEffect, useMemo } from "react";
import useExamsListQuery from "./useExamsListQuery";
import { useGlobalStore } from "./useGlobalStore";

const useExams = () => {
	const result = useExamsListQuery();

	const setIsPremiumUser = useGlobalStore((state) => state.setIsPremiumUser);
	const groupedExams = result.data ? groupExamsByCategory(result.data) : [];
	const examsList = useMemo(() => result.data ?? [], [result.data]);
	const entitlements = useMemo(() => getEntitlements(examsList), [examsList]);

	useEffect(() => {
		setIsPremiumUser(entitlements.length > 0);
		if (entitlements.length > 0) {
			updateUserProperties({
				premium_user: "true",
				products_purchased: JSON.stringify(
					entitlements.map(({ id, productType }) => ({
						id,
						type: productType,
					})),
				),
			});
		}
	}, [entitlements, setIsPremiumUser]);
	const categories = result.data
		? Array.from(
				new Map(
					result.data
						.flatMap((exam) => exam.exam.category)
						.map((category) => [category.id, category]),
				).values(),
			)
		: undefined;

	return { groupedExams, examsList, categories, ...result };
};

export default useExams;
